export default class TextUtil {
    static isEmptyText(content) {
        if (content) {
            const div = document.createElement('div');
            div.innerHTML = content;
            return '' === div.textContent.trim();
        } else {
            return true;
        }
    }

    static relaceQuotationMarks(text) {
        if(text) {
            return text.replaceAll("«", "„").replaceAll("»", "“");
        }
        return text;
    }
}
